// extracted by mini-css-extract-plugin
export default {"photo":"feedPhotosItem_photo__mVkND","visualization":"feedPhotosItem_visualization__fTguX"};